/**
 * ISO 3166-1 countries with flags, continents and dial codes.
 * Used by the CountryCityPicker in the register flow.
 */

export const CONTINENTS = {
  Africa:          { key: 'Africa',        emoji: '🌍', label: 'Africa' },
  Asia:            { key: 'Asia',          emoji: '🌏', label: 'Asia' },
  Europe:          { key: 'Europe',        emoji: '🇪🇺', label: 'Europe' },
  'North America': { key: 'North America', emoji: '🌎', label: 'North America' },
  'South America': { key: 'South America', emoji: '🌎', label: 'South America' },
  Oceania:         { key: 'Oceania',       emoji: '🏝️', label: 'Oceania' },
};

/** ISO code → flag emoji (regional indicator symbols) */
export function flagOf(code) {
  if (!code || code.length !== 2) return '🏳️';
  return String.fromCodePoint(
    ...code.toUpperCase().split('').map(c => 0x1f1e6 + c.charCodeAt(0) - 65)
  );
}

export const COUNTRIES = [
  { code:'AD', name:'Andorra', continent:'Europe', dial:'+376' },
  { code:'AE', name:'United Arab Emirates', continent:'Asia', dial:'+971' },
  { code:'AF', name:'Afghanistan', continent:'Asia', dial:'+93' },
  { code:'AG', name:'Antigua and Barbuda', continent:'North America', dial:'+1268' },
  { code:'AL', name:'Albania', continent:'Europe', dial:'+355' },
  { code:'AM', name:'Armenia', continent:'Asia', dial:'+374' },
  { code:'AO', name:'Angola', continent:'Africa', dial:'+244' },
  { code:'AR', name:'Argentina', continent:'South America', dial:'+54' },
  { code:'AT', name:'Austria', continent:'Europe', dial:'+43' },
  { code:'AU', name:'Australia', continent:'Oceania', dial:'+61' },
  { code:'AZ', name:'Azerbaijan', continent:'Asia', dial:'+994' },
  { code:'BA', name:'Bosnia and Herzegovina', continent:'Europe', dial:'+387' },
  { code:'BB', name:'Barbados', continent:'North America', dial:'+1246' },
  { code:'BD', name:'Bangladesh', continent:'Asia', dial:'+880' },
  { code:'BE', name:'Belgium', continent:'Europe', dial:'+32' },
  { code:'BF', name:'Burkina Faso', continent:'Africa', dial:'+226' },
  { code:'BG', name:'Bulgaria', continent:'Europe', dial:'+359' },
  { code:'BH', name:'Bahrain', continent:'Asia', dial:'+973' },
  { code:'BI', name:'Burundi', continent:'Africa', dial:'+257' },
  { code:'BJ', name:'Benin', continent:'Africa', dial:'+229' },
  { code:'BN', name:'Brunei', continent:'Asia', dial:'+673' },
  { code:'BO', name:'Bolivia', continent:'South America', dial:'+591' },
  { code:'BR', name:'Brazil', continent:'South America', dial:'+55' },
  { code:'BS', name:'Bahamas', continent:'North America', dial:'+1242' },
  { code:'BT', name:'Bhutan', continent:'Asia', dial:'+975' },
  { code:'BW', name:'Botswana', continent:'Africa', dial:'+267' },
  { code:'BY', name:'Belarus', continent:'Europe', dial:'+375' },
  { code:'BZ', name:'Belize', continent:'North America', dial:'+501' },
  { code:'CA', name:'Canada', continent:'North America', dial:'+1' },
  { code:'CD', name:'DR Congo', continent:'Africa', dial:'+243' },
  { code:'CF', name:'Central African Republic', continent:'Africa', dial:'+236' },
  { code:'CG', name:'Congo', continent:'Africa', dial:'+242' },
  { code:'CH', name:'Switzerland', continent:'Europe', dial:'+41' },
  { code:'CI', name:'Ivory Coast', continent:'Africa', dial:'+225' },
  { code:'CL', name:'Chile', continent:'South America', dial:'+56' },
  { code:'CM', name:'Cameroon', continent:'Africa', dial:'+237' },
  { code:'CN', name:'China', continent:'Asia', dial:'+86' },
  { code:'CO', name:'Colombia', continent:'South America', dial:'+57' },
  { code:'CR', name:'Costa Rica', continent:'North America', dial:'+506' },
  { code:'CU', name:'Cuba', continent:'North America', dial:'+53' },
  { code:'CV', name:'Cape Verde', continent:'Africa', dial:'+238' },
  { code:'CY', name:'Cyprus', continent:'Europe', dial:'+357' },
  { code:'CZ', name:'Czechia', continent:'Europe', dial:'+420' },
  { code:'DE', name:'Germany', continent:'Europe', dial:'+49' },
  { code:'DJ', name:'Djibouti', continent:'Africa', dial:'+253' },
  { code:'DK', name:'Denmark', continent:'Europe', dial:'+45' },
  { code:'DO', name:'Dominican Republic', continent:'North America', dial:'+1809' },
  { code:'DZ', name:'Algeria', continent:'Africa', dial:'+213' },
  { code:'EC', name:'Ecuador', continent:'South America', dial:'+593' },
  { code:'EE', name:'Estonia', continent:'Europe', dial:'+372' },
  { code:'EG', name:'Egypt', continent:'Africa', dial:'+20' },
  { code:'ER', name:'Eritrea', continent:'Africa', dial:'+291' },
  { code:'ES', name:'Spain', continent:'Europe', dial:'+34' },
  { code:'ET', name:'Ethiopia', continent:'Africa', dial:'+251' },
  { code:'FI', name:'Finland', continent:'Europe', dial:'+358' },
  { code:'FJ', name:'Fiji', continent:'Oceania', dial:'+679' },
  { code:'FR', name:'France', continent:'Europe', dial:'+33' },
  { code:'GA', name:'Gabon', continent:'Africa', dial:'+241' },
  { code:'GB', name:'United Kingdom', continent:'Europe', dial:'+44' },
  { code:'GE', name:'Georgia', continent:'Asia', dial:'+995' },
  { code:'GH', name:'Ghana', continent:'Africa', dial:'+233' },
  { code:'GM', name:'Gambia', continent:'Africa', dial:'+220' },
  { code:'GN', name:'Guinea', continent:'Africa', dial:'+224' },
  { code:'GQ', name:'Equatorial Guinea', continent:'Africa', dial:'+240' },
  { code:'GR', name:'Greece', continent:'Europe', dial:'+30' },
  { code:'GT', name:'Guatemala', continent:'North America', dial:'+502' },
  { code:'GW', name:'Guinea-Bissau', continent:'Africa', dial:'+245' },
  { code:'GY', name:'Guyana', continent:'South America', dial:'+592' },
  { code:'HK', name:'Hong Kong', continent:'Asia', dial:'+852' },
  { code:'HN', name:'Honduras', continent:'North America', dial:'+504' },
  { code:'HR', name:'Croatia', continent:'Europe', dial:'+385' },
  { code:'HT', name:'Haiti', continent:'North America', dial:'+509' },
  { code:'HU', name:'Hungary', continent:'Europe', dial:'+36' },
  { code:'ID', name:'Indonesia', continent:'Asia', dial:'+62' },
  { code:'IE', name:'Ireland', continent:'Europe', dial:'+353' },
  { code:'IL', name:'Israel', continent:'Asia', dial:'+972' },
  { code:'IN', name:'India', continent:'Asia', dial:'+91' },
  { code:'IQ', name:'Iraq', continent:'Asia', dial:'+964' },
  { code:'IR', name:'Iran', continent:'Asia', dial:'+98' },
  { code:'IS', name:'Iceland', continent:'Europe', dial:'+354' },
  { code:'IT', name:'Italy', continent:'Europe', dial:'+39' },
  { code:'JM', name:'Jamaica', continent:'North America', dial:'+1876' },
  { code:'JO', name:'Jordan', continent:'Asia', dial:'+962' },
  { code:'JP', name:'Japan', continent:'Asia', dial:'+81' },
  { code:'KE', name:'Kenya', continent:'Africa', dial:'+254' },
  { code:'KG', name:'Kyrgyzstan', continent:'Asia', dial:'+996' },
  { code:'KH', name:'Cambodia', continent:'Asia', dial:'+855' },
  { code:'KM', name:'Comoros', continent:'Africa', dial:'+269' },
  { code:'KR', name:'South Korea', continent:'Asia', dial:'+82' },
  { code:'KW', name:'Kuwait', continent:'Asia', dial:'+965' },
  { code:'KZ', name:'Kazakhstan', continent:'Asia', dial:'+7' },
  { code:'LA', name:'Laos', continent:'Asia', dial:'+856' },
  { code:'LB', name:'Lebanon', continent:'Asia', dial:'+961' },
  { code:'LK', name:'Sri Lanka', continent:'Asia', dial:'+94' },
  { code:'LR', name:'Liberia', continent:'Africa', dial:'+231' },
  { code:'LS', name:'Lesotho', continent:'Africa', dial:'+266' },
  { code:'LT', name:'Lithuania', continent:'Europe', dial:'+370' },
  { code:'LU', name:'Luxembourg', continent:'Europe', dial:'+352' },
  { code:'LV', name:'Latvia', continent:'Europe', dial:'+371' },
  { code:'LY', name:'Libya', continent:'Africa', dial:'+218' },
  { code:'MA', name:'Morocco', continent:'Africa', dial:'+212' },
  { code:'MC', name:'Monaco', continent:'Europe', dial:'+377' },
  { code:'MD', name:'Moldova', continent:'Europe', dial:'+373' },
  { code:'ME', name:'Montenegro', continent:'Europe', dial:'+382' },
  { code:'MG', name:'Madagascar', continent:'Africa', dial:'+261' },
  { code:'MK', name:'North Macedonia', continent:'Europe', dial:'+389' },
  { code:'ML', name:'Mali', continent:'Africa', dial:'+223' },
  { code:'MM', name:'Myanmar', continent:'Asia', dial:'+95' },
  { code:'MN', name:'Mongolia', continent:'Asia', dial:'+976' },
  { code:'MO', name:'Macao', continent:'Asia', dial:'+853' },
  { code:'MR', name:'Mauritania', continent:'Africa', dial:'+222' },
  { code:'MT', name:'Malta', continent:'Europe', dial:'+356' },
  { code:'MU', name:'Mauritius', continent:'Africa', dial:'+230' },
  { code:'MV', name:'Maldives', continent:'Asia', dial:'+960' },
  { code:'MW', name:'Malawi', continent:'Africa', dial:'+265' },
  { code:'MX', name:'Mexico', continent:'North America', dial:'+52' },
  { code:'MY', name:'Malaysia', continent:'Asia', dial:'+60' },
  { code:'MZ', name:'Mozambique', continent:'Africa', dial:'+258' },
  { code:'NA', name:'Namibia', continent:'Africa', dial:'+264' },
  { code:'NE', name:'Niger', continent:'Africa', dial:'+227' },
  { code:'NG', name:'Nigeria', continent:'Africa', dial:'+234' },
  { code:'NI', name:'Nicaragua', continent:'North America', dial:'+505' },
  { code:'NL', name:'Netherlands', continent:'Europe', dial:'+31' },
  { code:'NO', name:'Norway', continent:'Europe', dial:'+47' },
  { code:'NP', name:'Nepal', continent:'Asia', dial:'+977' },
  { code:'NZ', name:'New Zealand', continent:'Oceania', dial:'+64' },
  { code:'OM', name:'Oman', continent:'Asia', dial:'+968' },
  { code:'PA', name:'Panama', continent:'North America', dial:'+507' },
  { code:'PE', name:'Peru', continent:'South America', dial:'+51' },
  { code:'PG', name:'Papua New Guinea', continent:'Oceania', dial:'+675' },
  { code:'PH', name:'Philippines', continent:'Asia', dial:'+63' },
  { code:'PK', name:'Pakistan', continent:'Asia', dial:'+92' },
  { code:'PL', name:'Poland', continent:'Europe', dial:'+48' },
  { code:'PR', name:'Puerto Rico', continent:'North America', dial:'+1787' },
  { code:'PS', name:'Palestine', continent:'Asia', dial:'+970' },
  { code:'PT', name:'Portugal', continent:'Europe', dial:'+351' },
  { code:'PY', name:'Paraguay', continent:'South America', dial:'+595' },
  { code:'QA', name:'Qatar', continent:'Asia', dial:'+974' },
  { code:'RO', name:'Romania', continent:'Europe', dial:'+40' },
  { code:'RS', name:'Serbia', continent:'Europe', dial:'+381' },
  { code:'RU', name:'Russia', continent:'Europe', dial:'+7' },
  { code:'RW', name:'Rwanda', continent:'Africa', dial:'+250' },
  { code:'SA', name:'Saudi Arabia', continent:'Asia', dial:'+966' },
  { code:'SD', name:'Sudan', continent:'Africa', dial:'+249' },
  { code:'SE', name:'Sweden', continent:'Europe', dial:'+46' },
  { code:'SG', name:'Singapore', continent:'Asia', dial:'+65' },
  { code:'SI', name:'Slovenia', continent:'Europe', dial:'+386' },
  { code:'SK', name:'Slovakia', continent:'Europe', dial:'+421' },
  { code:'SL', name:'Sierra Leone', continent:'Africa', dial:'+232' },
  { code:'SN', name:'Senegal', continent:'Africa', dial:'+221' },
  { code:'SO', name:'Somalia', continent:'Africa', dial:'+252' },
  { code:'SR', name:'Suriname', continent:'South America', dial:'+597' },
  { code:'SS', name:'South Sudan', continent:'Africa', dial:'+211' },
  { code:'SV', name:'El Salvador', continent:'North America', dial:'+503' },
  { code:'SY', name:'Syria', continent:'Asia', dial:'+963' },
  { code:'SZ', name:'Eswatini', continent:'Africa', dial:'+268' },
  { code:'TD', name:'Chad', continent:'Africa', dial:'+235' },
  { code:'TG', name:'Togo', continent:'Africa', dial:'+228' },
  { code:'TH', name:'Thailand', continent:'Asia', dial:'+66' },
  { code:'TJ', name:'Tajikistan', continent:'Asia', dial:'+992' },
  { code:'TL', name:'Timor-Leste', continent:'Asia', dial:'+670' },
  { code:'TM', name:'Turkmenistan', continent:'Asia', dial:'+993' },
  { code:'TN', name:'Tunisia', continent:'Africa', dial:'+216' },
  { code:'TR', name:'Turkey', continent:'Asia', dial:'+90' },
  { code:'TT', name:'Trinidad and Tobago', continent:'North America', dial:'+1868' },
  { code:'TW', name:'Taiwan', continent:'Asia', dial:'+886' },
  { code:'TZ', name:'Tanzania', continent:'Africa', dial:'+255' },
  { code:'UA', name:'Ukraine', continent:'Europe', dial:'+380' },
  { code:'UG', name:'Uganda', continent:'Africa', dial:'+256' },
  { code:'US', name:'United States', continent:'North America', dial:'+1' },
  { code:'UY', name:'Uruguay', continent:'South America', dial:'+598' },
  { code:'UZ', name:'Uzbekistan', continent:'Asia', dial:'+998' },
  { code:'VE', name:'Venezuela', continent:'South America', dial:'+58' },
  { code:'VN', name:'Vietnam', continent:'Asia', dial:'+84' },
  { code:'YE', name:'Yemen', continent:'Asia', dial:'+967' },
  { code:'ZA', name:'South Africa', continent:'Africa', dial:'+27' },
  { code:'ZM', name:'Zambia', continent:'Africa', dial:'+260' },
  { code:'ZW', name:'Zimbabwe', continent:'Africa', dial:'+263' },
];

export const COUNTRY_BY_CODE = Object.fromEntries(COUNTRIES.map(c => [c.code, c]));

export function searchCountries(term, continent) {
  const t = (term || '').toLowerCase().trim();
  return COUNTRIES.filter(c =>
    (!continent || c.continent === continent) &&
    (!t || c.name.toLowerCase().includes(t) || c.code.toLowerCase() === t)
  );
}

/** Best-effort country guess from the browser timezone */
export function guessCountry() {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    const map = {
      'Europe/Bucharest': 'RO', 'Europe/London': 'GB', 'Europe/Paris': 'FR',
      'Europe/Berlin': 'DE', 'Europe/Madrid': 'ES', 'Europe/Rome': 'IT',
      'Europe/Amsterdam': 'NL', 'Europe/Warsaw': 'PL', 'Europe/Lisbon': 'PT',
      'Europe/Vienna': 'AT', 'Europe/Athens': 'GR', 'Europe/Prague': 'CZ',
      'Europe/Budapest': 'HU', 'Europe/Dublin': 'IE', 'Europe/Stockholm': 'SE',
      'Europe/Oslo': 'NO', 'Europe/Copenhagen': 'DK', 'Europe/Helsinki': 'FI',
      'Europe/Zurich': 'CH', 'Europe/Brussels': 'BE', 'Europe/Sofia': 'BG',
      'Europe/Kyiv': 'UA', 'Europe/Moscow': 'RU', 'Europe/Istanbul': 'TR',
      'America/New_York': 'US', 'America/Chicago': 'US', 'America/Denver': 'US',
      'America/Los_Angeles': 'US', 'America/Toronto': 'CA', 'America/Vancouver': 'CA',
      'America/Mexico_City': 'MX', 'America/Sao_Paulo': 'BR', 'America/Buenos_Aires': 'AR',
      'America/Bogota': 'CO', 'America/Lima': 'PE', 'America/Santiago': 'CL',
      'Asia/Tokyo': 'JP', 'Asia/Shanghai': 'CN', 'Asia/Seoul': 'KR',
      'Asia/Singapore': 'SG', 'Asia/Dubai': 'AE', 'Asia/Kolkata': 'IN',
      'Asia/Bangkok': 'TH', 'Asia/Jakarta': 'ID', 'Asia/Manila': 'PH',
      'Asia/Karachi': 'PK', 'Asia/Tel_Aviv': 'IL', 'Asia/Jerusalem': 'IL',
      'Africa/Cairo': 'EG', 'Africa/Lagos': 'NG', 'Africa/Johannesburg': 'ZA',
      'Africa/Nairobi': 'KE', 'Africa/Casablanca': 'MA', 'Africa/Accra': 'GH',
      'Australia/Sydney': 'AU', 'Australia/Melbourne': 'AU', 'Pacific/Auckland': 'NZ',
    };
    if (map[tz]) return { code: map[tz], timezone: tz };
    const region = tz.split('/')[0];
    const fallback = { Europe: 'GB', America: 'US', Asia: 'SG', Africa: 'NG', Australia: 'AU', Pacific: 'NZ' };
    return { code: fallback[region] || null, timezone: tz };
  } catch {
    return { code: null, timezone: null };
  }
}

export const getTimezone = () => {
  try { return Intl.DateTimeFormat().resolvedOptions().timeZone; } catch { return null; }
};